import { Box, Stack, Typography } from "@mui/material";
import { useAlerts } from "components/Alerts/AlertProvider";
import { EncampyEPlanPaymentLauncher } from "components/Encampy/EPlanPaymentLauncher";
import { useReportDetails } from "../useReportDetails";

export const EPlanPayPalPayment: React.FC = () => {
  const { data: reportData } = useReportDetails();
  const alerts = useAlerts();

  const report = reportData?.tierIIReport;
  const credential = report?.facility.portalCredential?.credential;

  // This should not happen, but just in case...
  if (!credential?.username || !credential?.password) {
    return (
      <Box sx={{ my: 2 }}>
        <Typography variant="body1" color="error">
          No E-Plan portal credentials found for this facility. Please ensure
          the facility has valid E-Plan credentials configured.
        </Typography>
      </Box>
    );
  }

  // Same here, this should not happen...
  if (!report?.portalReportId) {
    return (
      <Box sx={{ my: 2 }}>
        <Typography variant="body1" color="warning.main">
          No portal report ID found. The report may need to be submitted to
          E-Plan before making a payment.
        </Typography>
      </Box>
    );
  }

  return (
    <Stack direction="column" spacing={2} sx={{ my: 2 }}>
      <Typography variant="body1">1. Complete the payment in E-Plan</Typography>

      <Box>
        <EncampyEPlanPaymentLauncher
          username={credential.username}
          password={credential.password}
          reportingYear={report.reportingYear}
          portalReportId={report.portalReportId}
          onError={(error) => {
            alerts.error(`Failed to launch Encampy: ${error}`);
          }}
          onSuccess={() => {
            alerts.success(
              "Encampy launched successfully. Complete the payment and then mark this activity as complete."
            );
          }}
        />
      </Box>

      <Typography variant="body1">
        2. After completing the payment, click "Complete Activity" below to
        proceed with the workflow.
      </Typography>

      <Typography variant="body2">
        ⚠️ The next activity will download the receipt and the report documents
        from E-Plan, so please ensure the payment is fully processed before
        completing this activity.
      </Typography>
    </Stack>
  );
};
